import { render, staticRenderFns } from "./PermissionDocEdit.vue?vue&type=template&id=d1275b48&scoped=true&"
import script from "./PermissionDocEdit.vue?vue&type=script&lang=js&"
export * from "./PermissionDocEdit.vue?vue&type=script&lang=js&"
import style0 from "./PermissionDocEdit.vue?vue&type=style&index=0&id=d1275b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1275b48",
  null
  
)

export default component.exports